import { render, staticRenderFns } from "./OperationsList.vue?vue&type=template&id=5f61d6ee&"
import script from "./OperationsList.vue?vue&type=script&lang=js&"
export * from "./OperationsList.vue?vue&type=script&lang=js&"
import style0 from "./OperationsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports